/* eslint-disable no-nested-ternary */
import { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiUserPlus } from 'react-icons/fi';
import OrdersTableSkeleton from '../components/OrdersTableSkeleton';
import { useGetBusinessInvitationsQuery, useGetBusinessUsersQuery } from '../store';
import CustomModal from '../components/atoms/CustomModal';
import UsersTable from '../components/UsersTable';
import InvitationDTO from '../models/invitation';
import InvitationsTable from '../components/InvitationsTable';
import InviteUser from '../components/InviteUser';
import AdminSectionTitle from '../components/AdminSectionTitle';
import { IconPlay2 } from '../components/icons';
import HorizontalTabs from '../components/atoms/HorizontalTabs';

const AdminUsersPage: React.FC = () => {
  const { business_id: businessId } = useParams<{ business_id: string }>();
  if (!businessId || !(businessId)) {
    throw new Error('invalid business id');
  }

  const [showModal, setShowModal] = useState(false);
  const [tab, setTab] = useState<'users' | 'invitations'>('users');
  const [pendingInvitations, setPendingInvitations] = useState<InvitationDTO[]>([]);

  const { data: users, isFetching: isFetchingUsers } = useGetBusinessUsersQuery({
    businessId,
  });

  const { data: invitations, isFetching: isFetchingInvitations } = useGetBusinessInvitationsQuery({
    businessId,
  });

  const handleSucessInviteUser = () => {
    setShowModal(false);
  };

  const handleInviteUser = () => {
    setShowModal(true);
  };

  useEffect(() => {
    setPendingInvitations(invitations?.filter((i) => i.status === 'pending') || []);
  }, [invitations]);

  return (
    <div className="my-6 flex flex-col gap-6">
      <AdminSectionTitle
        title="Productoras"
        subtitle='Configuración de usuarios'
        icon={<IconPlay2 className='w-12 h-12 rotate-180' />}
      />
      <div className="glass-surface flex flex-col gap-4">
        <HorizontalTabs
          tabs={[
            { label: 'Usuarios', onClick: () => setTab('users'), selected: tab === 'users' },
            { label: 'Invitaciones', onClick: () => setTab('invitations'), selected: tab === 'invitations' },
          ]}
        />
        {tab === 'users' && (
          <div>
            {isFetchingUsers && <OrdersTableSkeleton />}{' '}
            {users && !isFetchingUsers && (
              <UsersTable users={users} businessId={businessId} />
            )}
          </div>
        )}
        {tab === 'invitations' && (
          <div>
            {isFetchingInvitations && <OrdersTableSkeleton />}{' '}
            {pendingInvitations && !isFetchingInvitations && (
              <InvitationsTable invitations={pendingInvitations} customButton={{
                label: 'Invitar usuario',
                onClick: handleInviteUser,
                variant: 'secondary',
                icon: <FiUserPlus className='text-xl' />,
              }} />
            )}
          </div>
        )}
      </div>

      <CustomModal
        onRequestClose={() => setShowModal(false)}
        isOpen={showModal}
        hideCancelButton
        overflowVisible
      >
        <Fragment>
          <div className="flex flex-col mb-4 md:min-w-[400px]">
            <h1 className="text-xl font-medium mb-2">Invitar usuario</h1>
            <p className="text-text-tertiary text-sm">
              Podrás invitar usuarios a tu productora
            </p>
          </div>
          <InviteUser onSuccess={handleSucessInviteUser} onCancel={() => setShowModal(false)} businessId={businessId} />
        </Fragment>
      </CustomModal>
    </div>
  );
};

export default AdminUsersPage;
